import { LoadSearchFilterFormData } from "models/Load";
import { IRateTrend } from "models/RateTrend";
import { TruckFilterFormData } from "models/Truck";
import { AuthUserAccount, CurrentUserByType, UserPermission } from "models/User";
import { RootState } from "store";

export const selectAccount = (
  state: RootState
): {
  account: CurrentUserByType;
  userDetails: AuthUserAccount;
  userPermission: UserPermission;
  loadFormFields: LoadSearchFilterFormData;
  truckFormFields: TruckFilterFormData;
  rateTrendFormFields: IRateTrend;
} => state.authState;

export const selectUserPermission = (state: RootState) => state.authState.userPermission;
